import {
    ChildrenBlock,
    defineBlock,
    smartProps,
} from '@smartfire/js-block-engine';
import { EditableHeading, EditableText } from '@smartfire/components';
import style from './style.module.scss';

export const Retailers = () => {
    return (
        <div className={style.block}>
            <EditableHeading smartProp="title" placeholder="Titre..." className={style.title}/>
            <EditableText smartProp="text" placeholder="Sous titre..." tagName="p" className={style.subtitle} />
            <ChildrenBlock
                gutenbergEditorConfig={{
                    allowedBlocks: [ 'smartfire/retailers---retailer'],
                    template: [
                        ['smartfire/retailers---retailer'],
                        ['smartfire/retailers---retailer'],
                        ['smartfire/retailers---retailer'],
                        ['smartfire/retailers---retailer'],
                        ['smartfire/retailers---retailer'],
                    ],
                }}
                className={style.children}
            />
        </div>
    );
};

export default defineBlock({
    Block: Retailers,
    smartProps: {
        title: smartProps.object.withDefault({
            headingLevel: 2,
            content: '',
        }),
        text: smartProps.string.withDefault(''),
        image: smartProps.image,
    },
    setup: {
        title: 'Revendeurs',
    },
});
